import React from 'react';
import { RBTPerformanceReport as RBTPerformanceReportData } from '../../models/Report';
import { ExportDropdown } from './ExportDropdown';
import { rowsToCsv, downloadCsv, todayStamp } from '../../utils/csv';

interface Props {
  data: RBTPerformanceReportData | null;
  selectedRbtId: string;
  onSelectRbt: (rbtId: string) => void;
  onBack?: () => void;
}

export const RBTPerformanceReport: React.FC<Props> = ({ data, selectedRbtId, onSelectRbt }) => {
  const handleExportCSV = () => {
    if (!data) return;
    const csv = rowsToCsv(data.billingCodes, [
      { header: 'Code', get: (r) => r.code },
      { header: 'Count', get: (r) => r.count },
      { header: 'Hours', get: (r) => r.hours },
    ]);
    const safeName = data.rbtName.replace(/[^a-z0-9_-]/gi, '_');
    downloadCsv(`rbt-performance_${safeName}_${todayStamp()}.csv`, csv);
  };

  return (
  <div>
    {/* Toolbar */}
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 'var(--spacing-4)' }}>
      <ExportDropdown onExportCSV={handleExportCSV} disabled={!data} />
    </div>

    <div className="card" style={{ marginBottom: 'var(--spacing-6)' }}>
      <label className="form-label">Select RBT</label>
      <input
        type="text"
        className="form-input"
        placeholder="Enter RBT ID"
        value={selectedRbtId}
        onChange={(e) => onSelectRbt(e.target.value)}
      />
      <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)', marginTop: 'var(--spacing-2)' }}>
        Enter an RBT user ID to view their performance report
      </p>
    </div>

    {data && (
      <>
        <h2 style={{ marginBottom: 'var(--spacing-4)' }}>
          Performance Report: {data.rbtName}
        </h2>

        <div className="grid grid-cols-4" style={{ gap: 'var(--spacing-4)', marginBottom: 'var(--spacing-6)' }}>
          <div className="card">
            <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)' }}>
              Total Sessions
            </div>
            <div style={{ fontSize: 'var(--text-2xl)', fontWeight: 'var(--font-bold)' }}>
              {data.totalSessions}
            </div>
          </div>
          <div className="card">
            <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)' }}>
              Total Hours
            </div>
            <div style={{ fontSize: 'var(--text-2xl)', fontWeight: 'var(--font-bold)' }}>
              {data.totalHours}
            </div>
          </div>
          <div className="card">
            <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)' }}>
              Location Verification
            </div>
            <div style={{ fontSize: 'var(--text-2xl)', fontWeight: 'var(--font-bold)', color: 'var(--color-success)' }}>
              {data.locationVerificationRate}%
            </div>
          </div>
          <div className="card">
            <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)' }}>
              Clients Served
            </div>
            <div style={{ fontSize: 'var(--text-2xl)', fontWeight: 'var(--font-bold)' }}>
              {data.clientsServed}
            </div>
          </div>
        </div>

        <div className="card">
          <h3 style={{ marginBottom: 'var(--spacing-4)' }}>Billing Codes</h3>
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Count</th>
                  <th>Hours</th>
                </tr>
              </thead>
              <tbody>
                {data.billingCodes.map((code) => (
                  <tr key={code.code}>
                    <td>{code.code}</td>
                    <td>{code.count}</td>
                    <td>{code.hours}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </>
    )}
  </div>
  );
};
